import {  NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { BaseHeaderLayoutModule } from "../../base-layouts";
import { HeaderLayoutComponent } from "./header-layout.component";
import { BranchHeaderComponent } from "./branch/branch-header.component";
import { GspMaterialModule } from "../../modules";

@NgModule({
    declarations: [
        HeaderLayoutComponent,
        BranchHeaderComponent
    ],
    imports: [
        CommonModule,
        BaseHeaderLayoutModule,
        GspMaterialModule
    ],
    exports: [
        HeaderLayoutComponent,
        BranchHeaderComponent
    ],
   
})
export class HeaderLayoutModule{

}
